import { component as defineComponent } from 'flightjs';

function Testimonial() {
    this.defaultAttrs({
        'show-hide-button': '[data-testimonial-show-hide-button]',
        'show-hide-button-text': '[data-testimonial-show-hide-button-text]',
        'show-hide-form': '[data-testimonial-show-hide-form]',
        'show-hide-input': '[data-testimonial-show-hide-input]',
        'show-hide-icon': '[data-testimonial-show-hide-icon]',
    });

    this.after('initialize', function () {
        this.on('click', {
            'show-hide-button': this.toggleHidden,
        });

        this.on('dataShowHideFormSubmitSuccess', this.updateShowHide);
    });

    this.toggleHidden = function (e) {
        e.preventDefault();
        const url = this.select('show-hide-form').attr('action');
        const formData = this.select('show-hide-form').serialize();
        this.trigger(this.$node, 'uiNeedsShowHideFormSubmit', {
            url,
            formData,
        });
    };

    this.updateShowHide = function (e, data) {
        const published = data.response.published;
        this.select('show-hide-input').val(!published);
        if (published) {
            this.$node
                .removeAttr('data-testimonial-hidden')
                .removeClass('testimonial--hidden');
            const hideCopy = this.select('show-hide-button-text').attr('data-testimonial-hide-copy');
            this.select('show-hide-button-text').text(hideCopy);
            this.select('show-hide-icon').removeClass('icon--watch-1').addClass('icon--blind-1');
        } else {
            this.$node
                .attr('data-testimonial-hidden', '')
                .addClass('testimonial--hidden');
            const showCopy = this.select('show-hide-button-text').attr('data-testimonial-show-copy');
            this.select('show-hide-button-text').text(showCopy);
            this.select('show-hide-icon').removeClass('icon--blind-1').addClass('icon--watch-1');
        }
    };
}

export default defineComponent(Testimonial);



// WEBPACK FOOTER //
// ./src/js/component_ui/testimonial.js